import { motion } from 'framer-motion';
import { FiGithub, FiLinkedin, FiMail } from 'react-icons/fi';

const Hero = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
      <div className="text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="mb-8"
        >
          <div className="w-32 h-32 md:w-40 md:h-40 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 mx-auto mb-6 overflow-hidden border-4 border-white/10 shadow-xl">
            <img 
              src="/profile.jpg" 
              alt="Shashikant Suthar" 
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-blue-400 to-purple-500 bg-clip-text text-transparent">
            Shashikant Suthar
          </h1>
          <h2 className="text-xl md:text-2xl text-gray-300 mb-6">
            Software Developer & Problem Solver
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto mb-8">
            I build exceptional digital experiences with modern technologies and clean, efficient code.
          </p>
          
          <div className="flex justify-center space-x-6">
            <motion.a
              whileHover={{ y: -3 }}
              href="https://github.com/Shashikant-nagal"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="GitHub"
            >
              <FiGithub size={24} />
            </motion.a>
            <motion.a
              whileHover={{ y: -3 }}
              href="http://linkedin.com/in/shashikant-shashikant-4b6b8136b"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <FiLinkedin size={24} />
            </motion.a>
            <motion.a
              whileHover={{ y: -3 }}
              href="mailto:shashikantsuthar0@gmail.com"
              className="text-gray-300 hover:text-white transition-colors"
              aria-label="Email"
            >
              <FiMail size={24} />
            </motion.a>
          </div>
        </motion.div>
        
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
          className="mt-16"
        >
          <div className="flex justify-center space-x-4">
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#contact"
              className="px-8 py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg font-medium shadow-lg hover:shadow-xl transition-all"
            >
              Get In Touch
            </motion.a>
            <motion.a
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              href="#projects"
              className="px-8 py-3 bg-transparent border-2 border-blue-400 text-blue-400 rounded-lg font-medium hover:bg-blue-400/10 transition-colors"
            >
              View My Work
            </motion.a>
          </div>
          
          <motion.div 
            className="mt-12 animate-bounce"
            animate={{ y: [0, 10, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
          >
            <div className="h-8 w-5 border-2 border-blue-400 rounded-full flex justify-center">
              <motion.div 
                className="w-1 h-2 bg-blue-400 rounded-full mt-1"
                animate={{ y: [0, 8, 0] }}
                transition={{ repeat: Infinity, duration: 1.5 }}
              />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
